const convertSingleTime = (hour, min) => {
    const h = parseInt(hour);
    const m = parseInt(min);
    const ampm = h >= 12 ? 'PM' : 'AM';
    const displayHour = h % 12 || 12;
    const mins = m.toString().padStart(2, '0');
    return `${displayHour}:${mins} ${ampm}`;
};

export const convertTo12Hour = (hoursData) => {
    if (!hoursData) return '';

    // Handle object format {open: "09:00", close: "18:00"}
    if (typeof hoursData === 'object' && hoursData.open && hoursData.close) {
        const [openH, openM] = hoursData.open.split(':');
        const [closeH, closeM] = hoursData.close.split(':');
        return `${convertSingleTime(openH, openM)} - ${convertSingleTime(closeH, closeM)}`;
    }

    // Handle string formats
    if (typeof hoursData === 'string') {
        const timeRangeMatch = hoursData.match(/(\d{1,2}):(\d{1,2})\s*-\s*(\d{1,2}):(\d{1,2})/);
        if (timeRangeMatch) {
            const [, openH, openM, closeH, closeM] = timeRangeMatch;
            return `${convertSingleTime(openH, openM)} - ${convertSingleTime(closeH, closeM)}`;
        }

        const singleTimeMatch = hoursData.match(/(\d{1,2}):(\d{1,2})/);
        if (singleTimeMatch) {
            const [, h, m] = singleTimeMatch;
            return convertSingleTime(h, m);
        }
    }

    return String(hoursData);
};
